module.exports = __webpack_public_path__ + "src/assets/mid_autumn_2017/4.jpg";